<template>
  <div class="container">
    <n-button type="primary" round @click.native="Back()" icon>
      <i class="now-ui-icons arrows-1_minimal-left"></i>
    </n-button>
    <div class="row">
      <div class="col-12">
        <div v-html="settings.termsAndConditionText" v-if="settings">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "signin-terms-of-use",
  async mounted() {
    let tenant = await this.$store.dispatch("getTenantName");
    //get terms and condition text
    let response = await this.$store.dispatch("getPublicConfigurationByType", {
      tenant: tenant,
      type: "termsAndConditionText",
    });
    if (response && response.value) {
      this.settings.termsAndConditionText = response.value;
    }
    this.$forceUpdate();
  },
  methods: {
    Back() {
      this.$router.push("/signin");
    },
  },
};
</script>
